module.exports = __webpack_public_path__ + "img/home.52dd3d4d.png";